export const getMousePosition = ($event: any) => {
  if ($event.targetTouches || $event.changedTouches) {
    const firstTouch = $event.targetTouches.item(0) || $event.changedTouches.item(0);
    return {
      x: firstTouch.clientX,
      y: firstTouch.clientY
    };
  } else {
    return {
      x: $event.clientX,
      y: $event.clientY
    };
  }
};
